
                module.exports = {
                  join: (...args) => args.join('/'),
                  dirname: (path) => path.split('/').slice(0, -1).join('/'),
                  basename: (path) => path.split('/').pop()
                };
              